export default __webpack_public_path__ + "static/media/globe-timezone-white.2d9a8049.svg";